<div id="oops">
  <div class="content">
    <a [routerLink]="['/']">
      <img src="./assets/logo.svg">
    </a>

    <h1>A página que tentou acessar não existe.</h1>
  </div>
</div>
